import React, { forwardRef } from 'react'
import { connect } from 'react-redux';
import Moment from 'moment';
import DatePicker from "react-datepicker";
import InputMask from 'react-input-mask';

import "react-datepicker/dist/react-datepicker.css";

import './Details.css'

class DetailsPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: props.bid.estimatedStartDateDisplay || null,
            bidDueDate: props.bid.bidDueDate || null,
            bidSubmittedDate: props.bid.bidSubmittedDate || null
        };

        this.onDateChange = this.onDateChange.bind(this);
        this.onBidDueDateChange = this.onBidDueDateChange.bind(this);
        this.onBidSubmittedDateChange = this.onBidSubmittedDateChange.bind(this);
        this.isWeekday = this.isWeekday.bind(this);
        this.bidDueDateId = 'bidDueDate';
        this.bidSubmittedDateId = 'bidSubmittedDate';
        this.startDateId = 'estimatedStartDate';
    }

    componentDidUpdate(prevProps) {
        if (this.props.bid.estimatedStartDateDisplay !== prevProps.bid.estimatedStartDateDisplay) {
            this.setState(prevState => ({
                ...prevState,
                startDate: this.props.bid.estimatedStartDateDisplay || null
            }));
        }

        if (this.props.bid.bidDueDate !== prevProps.bid.bidDueDate) {
            this.setState(prevState => ({
                ...prevState,
                bidDueDate: this.props.bid.bidDueDate || null
            }));
        }

        if (this.props.bid.bidSubmittedDate !== prevProps.bid.bidSubmittedDate) {
            this.setState(prevState => ({
                ...prevState,
                bidSubmittedDate: this.props.bid.bidSubmittedDate || null
            }));
        }
    }
    handleInvalidDate(date) {
        if (date == null || date == "") {
            const newDate = new Date();
            return newDate.toDateString();
        }
        return date;
    }
    onDateChange(date) {
        this.setState(prevState => ({
            ...prevState,
            startDate: date
        }));

        document.getElementById(this.startDateId).value = date;

        this.props.bidCheck();
    }

    onBidDueDateChange(date) {

        this.setState(prevState => ({
            ...prevState,
            bidDueDate: date
        }));

        document.getElementById(this.bidDueDateId).value = date;

        this.props.bidCheck();
    }

    onBidSubmittedDateChange(date) {
        this.setState(prevState => ({
            ...prevState,
            bidSubmittedDate: date
        }));

        document.getElementById(this.bidSubmittedDateId).value = date;

        this.props.bidCheck();
    }

    isWeekday = (date) => {
        const day = date.getDay();
        return day !== 0 && day !== 6;
    };

    render() {
        const { userRoles, isCreate, bid, bids, bidCheck, user } = this.props,
            isBidAdmin = userRoles.some(role => role.roleId === 1 && role.assigned),
            enableAdminChanges = isBidAdmin || isCreate,
            userFullName = (user.firstName + ' ' + user.lastName);
        const DatepickerCustomInput = React.forwardRef(({ value, onChange, onClick, id, disabled }, ref) => (
            <div className="ui input" onClick={onClick}>
                <InputMask
                    id={id}
                    ref={ref}
                    mask="99-99-9999"
                    value={value}
                    onChange={onChange}
                    required={true}
                    disabled={disabled}
                />
            </div>
        ));
        const renderDate = (date) => {
            if (date != null) {
                return Moment(date).toDate();
            }
            else {
                return date;
            }
        }

        return (
            <div className="detailsPanel">
                <div className="row">
                    <div className="col-md-12 header">
                        <div className="bid-blk header">
                            <div className="row child-row">
                                {
                                    isCreate
                                        ? null
                                        : (
                                            <div className="col-md-4">
                                                <p>Created By:*</p>
                                                <input id="createdBy" disabled defaultValue={bid.createdBy} />
                                            </div>
                                        )
                                }
                                <div className="col-md-4">
                                    <p>Sales Person:*</p>
                                    <input
                                        id="salesPerson"
                                        defaultValue={isCreate ? userFullName : bid.salesPerson}
                                        onChange={bidCheck}
                                        disabled={!enableAdminChanges}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <p>Origination Date:</p>
                                    <input id="submissionDate" disabled={!enableAdminChanges} defaultValue={bid.submissionDateDisplay} />
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Bid Due Date:*</p>
                                    <DatePicker
                                        id={this.bidDueDateId}
                                        selected={renderDate(this.state.bidDueDate)}
                                        onChange={this.onBidDueDateChange}
                                        disabled={false}
                                        filterDate={this.isWeekday}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        customInput={<DatepickerCustomInput />}
                                        required={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <p>Bid Submitted Date:*</p>
                                    <DatePicker
                                        id={this.bidSubmittedDateId}
                                        selected={renderDate(this.state.bidSubmittedDate)}
                                        onChange={this.onBidSubmittedDateChange}
                                        disabled={false}
                                        filterDate={this.isWeekday}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        customInput={<DatepickerCustomInput />}
                                        required={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="bid-blk">
                            <p className="bid-blk-hdg">Customer Information</p>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Account Number:</p>
                                    <input id="accountId" defaultValue={bid.accountId} disabled={!enableAdminChanges} />
                                </div>
                                <div className="col-md-4">
                                    <p>Company Name:*</p>
                                    <input
                                        id="companyName"
                                        defaultValue={bid.companyName}
                                        onChange={bidCheck}
                                        disabled={!enableAdminChanges}
                                    />
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Contact Name:</p>
                                    <input id="contactName" defaultValue={bid.contactName} onChange={bidCheck} disabled={!enableAdminChanges} />
                                </div>
                                <div className="col-md-4">
                                    <p>Contact Phone:</p>
                                    <input id="contactPhone" defaultValue={bid.contactPhone} disabled={!enableAdminChanges} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="bid-blk">
                            <p className="bid-blk-hdg">Project Information</p>

                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Project Name:*</p>
                                    <input
                                        id="projectName"
                                        defaultValue={bid.projectName}
                                        onChange={bidCheck}
                                        disabled={!enableAdminChanges}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <p>Project Owner:*</p>
                                    <input
                                        id="projectOwner"
                                        defaultValue={bid.projectOwner}
                                        onChange={bidCheck}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <p>Project City:*</p>
                                    <input
                                        id="projectCity"
                                        defaultValue={bid.projectCity}
                                        onChange={bidCheck}
                                        disabled={!enableAdminChanges}
                                    />
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Project State:*</p>
                                    <select id="projectStateId" defaultValue={bid.projectStateId} onChange={bidCheck} disabled={!enableAdminChanges}>
                                        <option>Select</option>
                                        {
                                            bids.valuesData.projectStates.map((state, index) => {
                                                const disable = !state.isBidActive,
                                                    shouldHide = disable && bid.projectStateName != state.name;

                                                return shouldHide
                                                    ? null
                                                    : (
                                                        <option id={state.id} value={state.id} key={index} disabled={disable}>
                                                            {state.name}
                                                        </option>
                                                    );
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <p>Number of Units:*</p>
                                    <input
                                        id="numberOfUnits"
                                        defaultValue={bid.numberOfUnits}
                                        onChange={bidCheck}
                                        disabled={!enableAdminChanges}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <p>Unit Type:*</p>
                                    <select id="unitTypeId" onChange={bidCheck} disabled={!enableAdminChanges} defaultValue={bid.unitTypeId}>
                                        <option>Select</option>
                                        {
                                            bids.valuesData.unitTypes.map((unit, index) => {
                                                const disable = !unit.isActive,
                                                    shouldHide = disable && bid.unitTypeName != unit.name;

                                                return shouldHide
                                                    ? null
                                                    : (
                                                        <option id={unit.unitTypeId} value={unit.unitTypeId} key={index} disabled={disable}>
                                                            {unit.name}
                                                        </option>
                                                    );
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Estimated Start Date:*</p>
                                    <DatePicker
                                        id={this.startDateId}
                                        selected={renderDate(this.state.startDate)}
                                        onChange={this.onDateChange}
                                        disabled={!enableAdminChanges}
                                        filterDate={this.isWeekday}
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        customInput={<DatepickerCustomInput />}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <p>Status:</p>
                                    <select id="bidStatusId" disabled={!enableAdminChanges || isCreate} defaultValue={bid.bidStatusId}>
                                        <option>Select</option>
                                        {
                                            bids.valuesData.bidStatuses.map((status, index) => {
                                                const disable = !status.isActive,
                                                    shouldHide = disable && bid.bidStatusName != status.name;

                                                return shouldHide
                                                    ? null
                                                    : (
                                                        <option id={status.id} value={status.id} key={index} disabled={disable}>
                                                            {status.name}
                                                        </option>
                                                    )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <p>Bid Amount:*</p>
                                    <input
                                        id="bidAmount"
                                        defaultValue={bid.bidAmount}
                                        onChange={bidCheck}
                                        data-type="number" />
                                </div>
                                <div className="col-md-2">
                                    <p>Margin:*</p>
                                    <input
                                        id="margin"
                                        defaultValue={bid.margin}
                                        onChange={bidCheck}
                                        disabled={false}
                                        data-type="number" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="bid-blk">
                            <p className="bid-blk-hdg">Products Quoted</p>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Door Style Quoted*:</p>
                                    <input
                                        id="quotedDoorStyle"
                                        defaultValue={bid.quotedDoorStyle}
                                        onChange={bidCheck}
                                        disabled={false} />
                                </div>
                                <div className="col-md-4">
                                    <p>Cabinet Door Finish*:</p>
                                    <input
                                        id="cabinetDoorFinish"
                                        defaultValue={bid.cabinetDoorFinish}
                                        onChange={bidCheck}
                                        disabled={false} />
                                </div>
                                <div className="col-md-4">
                                    <p>Cabinet Specified*:</p>
                                    <input
                                        id="cabinetSpecified"
                                        defaultValue={bid.cabinetSpecified}
                                        onChange={bidCheck}
                                        disabled={false} />
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4">
                                    <p>Cabinet Manufacturer:</p>
                                    <select id="cabinetManufacturerId" defaultValue={bid.cabinetManufacturerId}>
                                        <option>Select</option>
                                        {
                                            bids.valuesData.cabinetManufacturers.map((mfg, index) => {
                                                const disable = !mfg.isActive,
                                                    shouldHide = disable && bid.cabinetManufacturerName != mfg.name;

                                                return shouldHide
                                                    ? null
                                                    : (
                                                        <option id={mfg.id} value={mfg.id} key={index} disabled={disable}>
                                                            {mfg.name}
                                                        </option>
                                                    )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <p>Vanity Tops Quoted:</p>
                                    <select id="vanityTopsId" defaultValue={bid.vanityTopsId}>
                                        <option>Select</option>
                                        {
                                            bids.valuesData.vanityTops.map((top, index) => {
                                                const disable = !top.isActive,
                                                    shouldHide = disable && bid.vanityTopsName != top.name;

                                                return shouldHide
                                                    ? null
                                                    : (
                                                        <option id={top.id} value={top.id} key={index} disabled={disable}>
                                                            {top.name}
                                                        </option>
                                                    );
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <p>Kitchen Tops Quoted:</p>
                                    <select id="kitchenTopsId" defaultValue={bid.kitchenTopsId}>
                                        <option>Select</option>
                                        {
                                            bids.valuesData.kitchenTops.map((top, index) => {
                                                const disable = !top.isActive,
                                                    shouldHide = disable && bid.kitchenTopsName != top.name;

                                                return shouldHide
                                                    ? null
                                                    : (
                                                        <option id={top.id} value={top.id} key={index} disabled={disable}>
                                                            {top.name}
                                                        </option>
                                                    );
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4 quoted">
                                    <input type="checkbox" id="installQuoted" defaultChecked={bid.installQuoted} />
                                    <span>Install Quoted</span>
                                </div>
                            </div>
                            <div className="row child-row">
                                <div className="col-md-4 quoted">
                                    <input type="checkbox" id="appliancePackageQuoted" defaultChecked={bid.appliancePackageQuoted} />
                                    <span>Appliance Package Quoted</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="bid-blk">
                            <p className="bid-blk-hdg">Notes</p>

                            <div className="row child-row">
                                <div className="col-md-12">
                                    <table className="notes table table-striped">
                                        <thead>
                                            <tr className="head">
                                                <th>Date</th>
                                                <th>By</th>
                                                <th>Note</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                bid.bidNotes.map((note, index) => {
                                                    const submissionDate = new Date(note.submissionDate);
                                                    return <tr key={index}>
                                                        <td>{submissionDate.getMonth() + 1 + "/" + submissionDate.getDate() + "/" + submissionDate.getFullYear()}</td>
                                                        <td>{note.createdBy}</td>
                                                        <td className="note">{note.note}</td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>

                                    <p className="noteadd">Enter Note:</p>
                                    <textarea className="noteadd" id="newNote" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    bids: state.bids,
    user: state.userManager.userInfo,
    userRoles: state.userManager.roles || []
});

export default connect(mapStateToProps)(DetailsPanel)